import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { emptyProgram, Program } from "../../../../interfaces/program";
import { getProgramSingle, updateProgram } from "../../../../services/program";

interface ProgramEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramEdit(props: ProgramEditProps) {
    const [program, setProgram] = useState<Program>(emptyProgram);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getProgramSingle(props.id)
            .then((response: any) => {
                setProgram(response.data);
                setLoading(false);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            date_start: event.target.date_start.value,
            date_end: event.target.date_end.value
        }
        updateProgram(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="program-edit-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Edit program") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { loading && 
                    <LoadingSpinner />
                }
                { !loading && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Control type="hidden" name="id" required defaultValue={ program.id } />
                            <Form.Group className="mb-3 field-name" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required defaultValue={ program.name } />
                            </Form.Group>
                            <Form.Group className="mb-3 field-description" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea" rows={5} defaultValue={ program.description } />
                            </Form.Group>
                            <Form.Group className="mb-3 field-date-start" controlId="date_start">
                                <Form.Label aria-required="true">{ t("Start date") }</Form.Label>
                                <Form.Control type="date" name="date_start" required
                                    defaultValue={ program.date_start } />
                            </Form.Group>
                            <Form.Group className="mb-3 field-date-end" controlId="date_end">
                                <Form.Label aria-required="true">{ t("End date") }</Form.Label>
                                <Form.Control type="date" name="date_end" required
                                    defaultValue={ program.date_end } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}